import { z } from 'zod';

/**
 * The property-contract leaf names a document analysis can extract and a fact key
 * can promote to (the backend's `ExtractableFieldKey`). Mirrored into the contract
 * so the operator taxonomy screen (IMM-500.5) can reject a `propertyFieldKey` that
 * maps to no real Objekt field at the request boundary. The backend keeps the
 * authoritative list (`extractable-property-schema.ts`); a guard test pins the two
 * in lockstep so this copy can never drift.
 */
export const EXTRACTABLE_PROPERTY_FIELD_KEYS = [
  'street',
  'houseNumber',
  'postalCode',
  'city',
  'district',
  'state',
  'country',
  'parcelNumber',
  'parcelSubdivision',
  'livingArea',
  'plotArea',
  'usableArea',
  'totalArea',
  'rooms',
  'bedrooms',
  'bathrooms',
  'floor',
  'floorsTotal',
  'yearBuilt',
  'lastRenovated',
  'condition',
  'interiorQuality',
  'constructionPhase',
  'certificateBasis',
  'energyClass',
  'energyValue',
  'primaryEnergyValue',
  'includesWarmWater',
  'certificateIssuedAt',
  'certificateValidUntil',
  'purchasePrice',
  'baseRent',
  'totalRent',
  'deposit',
] as const;

export const ExtractablePropertyFieldKeySchema = z.enum(EXTRACTABLE_PROPERTY_FIELD_KEYS);

export type ExtractablePropertyFieldKey = z.infer<typeof ExtractablePropertyFieldKeySchema>;
